var render = function render(){var _vm=this,_c=_vm._self._c;return _c('UiModal',_vm._g({attrs:{"cancel":_vm.cancel,"confirm":_vm.confirm,"size":_vm.size}},_vm.$listeners),[_c('div',{staticClass:"tw-text-center"},[_c('div',{staticClass:"tw-text-2xl tw-font-semibold"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"tw-mt-3"},[_vm._v(" "+_vm._s(_vm.message)+" ")]),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }